 /**
 * Portfolio module.
 *
 * @package Bamboo Theme
 */

// Main setup.
function bambooPortfolioDocumentReady() {

	// Initialise the filter dropdown.
	const url = new URL(location.href);
	const filter = url.searchParams.get("filter");
	if (filter) {
		jQuery('#portfolio-filter').val(filter);
	}

	jQuery('#portfolio-filter').on('change', function () {
		document.location.href = '?filter=' + jQuery(this).val();
	});

	// Enable clicking on the figcaption in portfolio items.
	jQuery('.portfolio-item figcaption').on('click', function(){
		var link = jQuery(this).parent().find('a').attr('href');
		document.location.href = link;
	});

}
jQuery( document ).ready( bambooPortfolioDocumentReady );